import { Commit } from "vuex";

const actions = {};

export default actions;
